import { combineReducers } from "redux";
import auth from "./auth";
import storeInfo from './storeInfo'
import ui from './ui'
import settings from './settings'
import cupons from './coupons'

export default combineReducers({ auth, storeInfo, ui, settings, cupons });
